import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { faTrash, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TokenService } from 'src/app/shared/services/token.service';
import { UsuarioService } from 'src/app/shared/services/usuario.service';
import Swal from 'sweetalert2';
import { HealthService } from '../../../services/saude/health.service';
@Component({
  selector: 'app-cancelar-plano',
  templateUrl: './cancelar-plano.component.html',
  styleUrls: ['./cancelar-plano.component.css']
})
export class CancelarPlanoComponent {
  //Icones
  faTriangleExclamation = faTriangleExclamation;
  faTrash = faTrash;
  //Variaveis locais
  beneficiaries!: any[];
  emails!: any[];
  plan!: any;
  loading: boolean = false;
  //Formulário
  formContact: FormGroup = new FormGroup({
    email: new FormControl(null, [Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$')]),
    confirm: new FormControl(false, [Validators.required])
  });
  constructor(private userService: UsuarioService, private healthService: HealthService, private router: Router) {
    this.getBeneficiaries();
  }
  protected getBeneficiaries(): void {
    // this.loadingBeneficiaries = true;
    this.healthService.getBeneficiaryAndHealthData().subscribe({
      next: (res: any) => {
        this.emails = [];
        this.beneficiaries = [];
        this.userService.getBeneficiaries().subscribe((res_second: any) => {
          res_second.forEach((element: any) => {
            if (element.titular) {
              this.userService.getUser(element.id).subscribe((res_third: any) => {
                this.emails.push(res_third.contactResponse.email);
                this.emails.push(res_third.contactResponse.secondaryEmail);
              });
            }
          })
        });
        res.forEach((element: any) => {
          if (element.titular) {
            this.plan = element.healthInsuranceName;
          }
          this.beneficiaries.push(
            {
              idSegurado: element.healthInsuranceContractNumber,
              name: element.name,
              cpf: element.cpf,
              titulariedade: element.titular
            }
          );
        });
        // this.loadingBeneficiaries = false;
      },
      error: error => {
        // this.errorBeneficiaries = true;
      },
    }
    );
  }
  protected removeEmail(index: number): void {
    this.emails.splice(index, 1);
  }
  protected adicionarEmail(): void {
    if (this.formContact.value.email && !this.formContact.get('email')?.invalid) {
      this.emails.push(this.formContact.value.email);
      this.formContact.get('email')?.reset();
    }
  }
  protected cancelPlan(): void {
    this.loading = true;
    //  this.textButton = "Solicitando Cancelamento...";
    Swal.fire({
      title: 'Deseja prosseguir com o cancelamento?',
      text: `Declaro que, no ato da minha solicitação de cancelamento do plano PROSAÚDE II, 
             fui devidamente informado pela Fundação Copel das consequências relativas ao 
             meu pedido de cancelamento, protocolado nesta data e hora.`,
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Voltar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.healthService.postDeleteBeneficiary({ cancel: true, solicitationExclusion: this.beneficiaries, email: this.emails }).subscribe({
          next: (pdf: any) => {
            this.downloadPdf(pdf);
            Swal.fire('Cancelamento Solicitado!', 'O cancelamento do seu plano foi solicitado com Sucesso!', 'success');
          }
        });
      } else if (result.isDenied) {
        this.router.navigate(['cancelar']);
      }
    });
  }
  downloadPdf(pdf: any) {
    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    a.download = 'Carta de Cancelamento.pdf';
    a.href = URL.createObjectURL(pdf.body);
    a.target = '_blank';
    a.click();
    document.body.removeChild(a);
  }
}
